import { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { roundNumber } from '../../Utils'
import InfoModal from '../modals/info-modal/InfoModal';

const TotalBlock = (props) => {
  const [show, setShow] = useState(false);
  const [monthlyRemaining, setMonthlyRemaining] = useState(0.00);
  const [weeklyRemaining, setWeeklyRemaining] = useState(0.00);
  
  const monthlyRemainingCalc = () => {
    setMonthlyRemaining(roundNumber(+props.incomeData.monthlyTotal - props.expenseData.monthlyTotal
        - (props.debtData.manual?props.debtData.totalPerMonthIndividual:
        props.debtData.totalPerMonthOverall)))
  }
  
  const weeklyRemainingCalc = () => {
    setWeeklyRemaining(roundNumber(+props.incomeData.weeklyTotal - props.expenseData.weeklyTotal
        - (props.debtData.manual?props.debtData.totalPerWeekIndividual:
        props.debtData.totalPerWeekOverall)))
  }
  
  const budgetAnalysis = () => {
    return (
      <>
      <p>You are spending more each {props.yearCalc?"month":"week"} than you have available from your income.</p>
      <p>You have set your total income to £{props.yearCalc?(+props.incomeData.monthlyTotal).toFixed(2):(+props.incomeData.weeklyTotal).toFixed(2)}
      &nbsp;but your total expenditure, including your debt payments are £
      {props.yearCalc?(+props.expenseData.monthlyTotal + +props.debtData.totalPerMonthIndividual).toFixed(2)
      :(+props.expenseData.weeklyTotal + +props.debtData.totalPerWeekIndividual)}.</p>
      <p>To get back on track, you need to reduce your expenditure by at least 
      £{props.yearCalc?Math.abs(monthlyRemaining * 1.1).toFixed(2):Math.abs(weeklyRemaining * 1.1).toFixed(2)} 
      &nbsp;which includes a 10% buffer.</p>
      </>
    )
  }
  
  useEffect(() => {
    monthlyRemainingCalc();
    weeklyRemainingCalc();
  }, [props.expenseData.monthlyTotal, props.incomeData.monthlyTotal, props.debtData.totalPerMonthOverall, props.debtData.totalPerMonthIndividual])
  
  useEffect(() => {
    if (monthlyRemaining >= 0 && weeklyRemaining >= 0) return;

    const timeoutId = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(timeoutId);
  }, [monthlyRemaining, weeklyRemaining])
  
  return(
    <Row>
      <Row>
        <hr/>
        <Col xs={11} md={5} lg={8} className="total-text">
          Remaining
        </Col>
        <Col xs={11} md={5}lg={2} className={monthlyRemaining>=0?"total-text":"total-text-neg"}>
          £{monthlyRemaining.toFixed(2)}
        </Col>
        <Col xs={11} md={5}lg={2} className={weeklyRemaining>=0?"total-text":"total-text-neg"}>
          £{weeklyRemaining.toFixed(2)}
        </Col>
        <Col xs={1}>
          &nbsp;
        </Col>
      </Row>
      <Row>
        <Col>
          <InfoModal 
            show={show}
            setShow={setShow}
            title='You are over budget'
            body={budgetAnalysis()}
            incomeData={props.incomeData}
            expenseData={props.expenseData}
            debtData={props.debtData}
            yearCalc={props.yearCalc}
          />
        </Col>
      </Row>
    </Row>
  );
};

export default TotalBlock;